<template>
	<div style="min-height: 70vh; max-height: 80vh" class="overflow-auto">
		<vx-card :title="null" class="mt-5">
			<vs-row vs-w="12">
				<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
					<div class="vx-row mb-6">
						<div class="vx-col w-full md:w-2/2">
							<v-select
								name="status"
								v-model="selectedTypeConfig"
								v-validate="'required'"
								value="id"
								label="name"
								:options="listTypeConfig"
								:clearable="false"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:change="changeTypeConfig(selectedTypeConfig)"
								:disabled="company.type_config_id == selectedTypeConfig.id"
								:getOptionLabel="(user) => user.name"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</div>
					</div>
					<div class="vx-row mb-6">
						<div
							class="vx-col w-full md:w-1/2"
							v-for="(key, index) in selectedTypeConfig.json_base"
							:key="key"
							:index="index"
						>
							<vx-input-group class="mb-base">
								<label class="g-label--normal" v-text="key"></label>
								<vs-input
									name="field"
									class="w-full"
									icon-pack="feather"
									icon="icon-briefcase"
									v-validate="typeConfigGeneral[key] === 'REQUIRED' ? 'required' : ''"
									icon-no-border
									v-model="itemsSelected[key]"
									:label-placeholder="
										typeConfigGeneral[key] === 'REQUIRED' ? key + ' (' + $t('Required') + ')' : key
									"
									:danger="
										typeConfigGeneral[key] === 'REQUIRED' ? validfields(itemsSelected[key]) : false
									"
								/>
								<span class="text-danger text-sm" v-show="errors.has(key)">
									{{ $t("Resource.Edit.ValidMessages.Dynamic.Text1") }} {{ key }}
									{{ $t("Resource.Edit.ValidMessages.Dynamic.Text2") }}
								</span>
								<template slot="append"></template>
							</vx-input-group>
						</div>
					</div>
					<div class="vx-row float-right">
						<div class="vx-col w-full">
							<vs-button
								color="danger"
								type="border"
								class="mb-2 mr-3 g-btn--resourcePopup"
								@click="cancelEdit"
								v-if="company.type_config_id == selectedTypeConfig.id ? true : false"
								>{{ $t("Cancel") }}
							</vs-button>
							<vs-button
								id="btn-submit-company"
								class="mb-2 g-btn--resourcePopup"
								color="success"
								:disabled="isFormValid != 0"
								@click="submitForm"
								>{{ $t("Save") }}
							</vs-button>
						</div>
					</div>
				</vs-col>
			</vs-row>
		</vx-card>
	</div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
import {dict} from "@/models/CompanyConfValidator.js";
import Commons from "@/helpers/commons.js";
import Company from "@/models/CompanyConf.js";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud";

// register custom messages
Validator.localize("en", dict);

export default {
	name: "CompanyForm",
	components: {
		Datepicker,
		"v-select": vSelect,
	},
	props: {
		data: Object,
	},
	data() {
		return {
			company: {...this.data},
			langEs: es,
			langEn: en,
			countries: [],
			cities: [],
			departments: [],
			selectedCountry: null,
			selectedCity: null,
			selectedDepartment: null,
			additionalFieldsEnable: false,
			newField: {
				name: "",
				value: "",
			},
			camposnuevos: {},
			selectedTypeConfig: {},
			configSelected: {},
			editable: false,
			itemsSelected: {},
			selected: {},
		};
	},
	computed: {
		listTypeConfig() {
			return this.$store.state.moduleCompanyConfigCrud.config_list;
		},
		typeConfigGeneral() {
			if (!this.$store.state.moduleCompanyConfigCrud.config_list || !this.selectedTypeConfig.id) {
				return {};
			}
			return this.$store.state.moduleCompanyConfigCrud.config_list.filter(
				(elem) => elem.id === this.selectedTypeConfig.id
			)[0]["json_base"];
		},
		// Valida que los campos no esten vacios
		validfields() {
			return (value) => (value == "" ? true : false);
		},
		// Genera las opciones dentro del select
		typeConfigOptions() {
			return Commons.generateSelectOptios(this.listCompanies, "name", "id");
		},
		// Valida si el formulario es valido, de ser asi habilita el boton
		isFormValid() {
			let track = 1;
			if (this.typeConfigGeneral && Object.keys(this.itemsSelected).length > 0) {
				let numberOfRequiredFieldsPending = 0;
				for (let key in this.typeConfigGeneral) {
					if (this.typeConfigGeneral[key] === "REQUIRED" && !this.itemsSelected[key]) {
						numberOfRequiredFieldsPending++;
					}
				}
				if (numberOfRequiredFieldsPending === 0) {
					return (track = 0);
				} else {
					return (track = 1);
				}
			}
			return track;
		},
	},
	methods: {
		// Determina si esta creando o editando
		changeTypeConfig(modelSelect) {
			if (this.selectedTypeConfig.id) {
				if (this.company.type_config_id !== 0) {
					if (this.company.type_config_id == modelSelect.id) {
						this.editable = true;
					} else {
						this.editable = false;
					}
				}
			}
		},
		// Click al submit
		submitForm() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.editable) {
						this.updateCompanyConfig();
					} else {
						this.createCompanyConfig();
					}
				}
			});
		},
		// Crea la configuración de compañia
		createCompanyConfig() {
			let arrayFinal = {};
			arrayFinal.type_config_id = this.selectedTypeConfig.id;
			arrayFinal.config_json = {...this.itemsSelected};
			if (this.$route.params.company_id) {
				arrayFinal["company_id"] = this.$route.params.company_id;
			}
			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/addCompanyConfig", arrayFinal)
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigCreate"),
						text: this.$t("TextConfirmCompanyConfigCreate"),
					});

					this.cancelEdit();
					this.$emit("updateCompanyConfigEmit");
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		// Actualiza la configuración de compañia
		updateCompanyConfig() {
			let arrayFinal = {};
			arrayFinal.type_config_id = this.selectedTypeConfig.id;
			arrayFinal.config_json = {...this.itemsSelected};
			arrayFinal.id = this.company.id;
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			arrayFinal["company_id"] = userInfo.datarutas_company_id;
			if (this.$route.params.company_id) {
				arrayFinal["company_id"] = this.$route.params.company_id;
			}
			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/updateCompanyConfig", arrayFinal)
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigUpdate"),
						text: this.$t("TextConfirmCompanyConfigUpdate"),
					});

					this.cancelEdit();
					this.$emit("updateCompanyConfigEmit");
				})
				.catch((err) => {
					this.$vs.loading.close();
					throw new Error(err);
				});
		},
		// Cancela la edicion
		cancelEdit() {
			this.$emit("changeActiveTabEmit", 0);
			this.company = new Company({});
			this.configSelected = {};
			this.itemsSelected = null;
			this.selectedTypeConfig = {};
		},
		loading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		consultListConfig() {
			this.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/getListConfig")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		consultOnlyCompanyConfig() {
			this.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/getOnlyConfig", this.company.type_config_id)
				.then((res) => {
					this.closeLoading();
					this.selectedTypeConfig = res.data;
					this.selectedTypeConfig.json_base = {
						...this.company.config_json,
					};
					this.itemsSelected = {
						...this.selectedTypeConfig.json_base,
					};
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
	},
	mounted() {
		setTimeout(() => {
			if (this.$route.params.company_id) {
				const foundConfig = this.listTypeConfig.find((el) => el.name === "SITIDATA");
				if (foundConfig) {
					this.selectedTypeConfig = foundConfig;
				}
			}
		}, 500);
	},
	created() {
		// Registra el modulo
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
		this.consultListConfig();
		// Si esta modificando, mapea la información
		if (this.company.type_config_id !== 0) {
			this.editable = true;
			this.consultOnlyCompanyConfig();
		} else {
			this.editable = false;
		}
	},
};
</script>
